<div class="card">
    <app-header titulo="Equipamentos" descricao="Gerenciamento e integração de equipamentos"></app-header>

    <p-table [value]="equipamentos"
             [globalFilterFields]="['codigoEquipamentoErp','descricaoEquipamento','codigoTipoEquipamento','codigoCentroCustoErp','codigoModelo','descricaoModelo','descricaoMarca','numeroPlaca','statusIntegracao','mensagem']"
             styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
             [rowsPerPageOptions]="[10,20,50,100]" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
             currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
             dataKey="codigoEquipamentoErp"
             [loading]="loading"
             #dt>

        <ng-template pTemplate="caption">
            <div class="flex justify-content-end flex-wrap">
                <div class="flex align-items-center justify-content-center">
                    <button class="ml-3 mr-3" pButton (click)="exportar()" style="font-size: 1.0rem" [loading]="loadingSincronizar" icon="pi pi-file-excel" label="Exportar"></button>
                </div>
                <div class="flex align-items-center justify-content-center">
                    <span class="p-input-icon-left ml-auto">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
                    </span>
                </div>
                <div class="flex align-items-center justify-content-center">
                    <button class="ml-3" pButton pRipple icon="pi pi-refresh" (click)="getAll()" [loading]="loading"></button>
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th style="min-width: 50px; text-align: center;">Detalhes</th>
                <th>Código</th>
                <th>Descrição</th>
                <th>Tipo</th>
                <th>Centro Custo</th>
                <th>Modelo</th>
                <th>Marca</th>
                <th>Placa</th>
                <th>Dt Recebido</th>
                <th>Status</th>
                <th>Dt Integrado</th>
                <th>Mensagem</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-equipamento>
            <tr>
                <td style="text-align: center;">
                    <p-button icon="pi pi-eye" [rounded]="true" [text]="true" severity="info" (onClick)="visualizarDetalhes(equipamento)" pTooltip="Ver detalhes" tooltipPosition="top"></p-button>
                </td>
                <td>{{ equipamento.codigoEquipamentoErp }}</td>
                <td>{{ equipamento.descricaoEquipamento }}</td>
                <td>{{ equipamento.codigoTipoEquipamento }}</td>
                <td>{{ equipamento.codigoCentroCustoErp }}</td>
                <td>{{ equipamento.codigoModelo }}</td>
                <td>{{ equipamento.descricaoMarca }}</td>
                <td>{{ equipamento.numeroPlaca }}</td>
                <td>{{ equipamento.dataRecebimento | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td><app-tag-status [status]="equipamento.statusIntegracao"></app-tag-status></td>
                <td>{{ equipamento.dataIntegracaoPims | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td>{{ equipamento.mensagem }}</td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <td colspan="12">Não há equipamentos integrados</td>
        </ng-template>

    </p-table>
</div>

<!-- Dialog de detalhes -->
<p-dialog [(visible)]="displayDetalhesDialog" [modal]="true"
          [style]="{width: '900px'}"
          [draggable]="false" [resizable]="false"
          header="Detalhes do Equipamento">

    <div *ngIf="equipamentoSelecionado">

        <div class="text-900 font-semibold mb-2">Identificação</div>
        <div class="grid mb-3">
            <div class="col-4"><span class="text-500">Código ERP:</span> <strong>{{ equipamentoSelecionado.codigoEquipamentoErp }}</strong></div>
            <div class="col-4"><span class="text-500">Descrição:</span> <strong>{{ equipamentoSelecionado.descricaoEquipamento }}</strong></div>
            <div class="col-4"><span class="text-500">Tipo Equipamento:</span> <strong>{{ equipamentoSelecionado.codigoTipoEquipamento }}</strong></div>
            <div class="col-4"><span class="text-500">Patrimônio:</span> <strong>{{ equipamentoSelecionado.codigoPatrimonio }}</strong></div>
            <div class="col-4"><span class="text-500">Tipo Recurso:</span> <strong>{{ equipamentoSelecionado.codigoTipoRecurso }}</strong></div>
            <div class="col-4"><span class="text-500">Tipo Componente:</span> <strong>{{ equipamentoSelecionado.codigoTipoComponente }}</strong></div>
        </div>

        <div class="text-900 font-semibold mb-2">Empresa e Localização</div>
        <div class="grid mb-3">
            <div class="col-3"><span class="text-500">Empresa ERP:</span> <strong>{{ equipamentoSelecionado.codigoEmpresaErp }}</strong></div>
            <div class="col-3"><span class="text-500">Filial ERP:</span> <strong>{{ equipamentoSelecionado.codigoFilialErp }}</strong></div>
            <div class="col-3"><span class="text-500">Centro de Custo:</span> <strong>{{ equipamentoSelecionado.codigoCentroCustoErp }}</strong></div>
            <div class="col-3"><span class="text-500">Munic. Licenciamento:</span> <strong>{{ equipamentoSelecionado.codigoMunicipioLicenciamento }}</strong></div>
            <div class="col-3"><span class="text-500">Empresa Proprietária:</span> <strong>{{ equipamentoSelecionado.codigoEmpresaProprietaria }}</strong></div>
            <div class="col-3"><span class="text-500">Empresa Usuária:</span> <strong>{{ equipamentoSelecionado.codigoEmpresaUsuaria }}</strong></div>
            <div class="col-3"><span class="text-500">Transportadora:</span> <strong>{{ equipamentoSelecionado.codigoTransportadora }}</strong></div>
            <div class="col-3"><span class="text-500">Un. Medida:</span> <strong>{{ equipamentoSelecionado.codigoUnidadeMedida }}</strong></div>
        </div>

        <div class="text-900 font-semibold mb-2">Classificação Técnica</div>
        <div class="grid mb-3">
            <div class="col-6"><span class="text-500">Modelo:</span> <strong>{{ equipamentoSelecionado.codigoModelo }} {{ equipamentoSelecionado.descricaoModelo }}</strong></div>
            <div class="col-6"><span class="text-500">Marca:</span> <strong>{{ equipamentoSelecionado.codigoMarca }} {{ equipamentoSelecionado.descricaoMarca }}</strong></div>
            <div class="col-6"><span class="text-500">Grupo Operacional:</span> <strong>{{ equipamentoSelecionado.codigoGrupoOperacional }} {{ equipamentoSelecionado.descricaoGrupoOperacional }}</strong></div>
            <div class="col-6"><span class="text-500">Categoria Operacional:</span> <strong>{{ equipamentoSelecionado.codigoCategoriaOperacional }} {{ equipamentoSelecionado.descricaoCategoriaOperacional }}</strong></div>
            <div class="col-6"><span class="text-500">Classe de Potência:</span> <strong>{{ equipamentoSelecionado.codigoClassePotencia }} {{ equipamentoSelecionado.descricaoClassePotencia }}</strong></div>
            <div class="col-6"><span class="text-500">Horas Jornada:</span> <strong>{{ equipamentoSelecionado.quantidadeHorasJornada }}</strong></div>
        </div>

        <div class="text-900 font-semibold mb-2">Veículo</div>
        <div class="grid mb-3">
            <div class="col-3"><span class="text-500">Placa:</span> <strong>{{ equipamentoSelecionado.numeroPlaca }}</strong></div>
            <div class="col-3"><span class="text-500">Chassi:</span> <strong>{{ equipamentoSelecionado.numeroChassi }}</strong></div>
            <div class="col-3"><span class="text-500">Ano Fabricação:</span> <strong>{{ equipamentoSelecionado.numeroAnoFabricacao }}</strong></div>
            <div class="col-3"><span class="text-500">Ano Modelo:</span> <strong>{{ equipamentoSelecionado.numeroAnoModelo }}</strong></div>
        </div>

        <div class="text-900 font-semibold mb-2">Flags de Controle</div>
        <div class="grid mb-3">
            <div class="col-2"><span class="text-500">Tp. Operador:</span> <strong>{{ equipamentoSelecionado.flagTipoOperador }}</strong></div>
            <div class="col-2"><span class="text-500">Abastecimento:</span> <strong>{{ getFlagLabel(equipamentoSelecionado.flagAbastecimento) }}</strong></div>
            <div class="col-2"><span class="text-500">Lubrificação:</span> <strong>{{ getFlagLabel(equipamentoSelecionado.flagLubrificacao) }}</strong></div>
            <div class="col-2"><span class="text-500">Pneu:</span> <strong>{{ getFlagLabel(equipamentoSelecionado.flagPneu) }}</strong></div>
            <div class="col-2"><span class="text-500">Manutenção:</span> <strong>{{ getFlagLabel(equipamentoSelecionado.flagManutencao) }}</strong></div>
            <div class="col-2"><span class="text-500">Disponibilidade:</span> <strong>{{ getFlagLabel(equipamentoSelecionado.flagDisponibilidade) }}</strong></div>
        </div>

        <div class="text-900 font-semibold mb-2">Datas e Integração</div>
        <div class="grid">
            <div class="col-3"><span class="text-500">Data Aquisição:</span> <strong>{{ equipamentoSelecionado.dataAquisicao | date: 'dd/MM/yyyy' }}</strong></div>
            <div class="col-3"><span class="text-500">Data Recebimento:</span> <strong>{{ equipamentoSelecionado.dataRecebimento | date: 'dd/MM/yyyy HH:mm' }}</strong></div>
            <div class="col-3"><span class="text-500">Data Integração PIMS:</span> <strong>{{ equipamentoSelecionado.dataIntegracaoPims | date: 'dd/MM/yyyy HH:mm' }}</strong></div>
            <div class="col-3"><span class="text-500">Última Atualização:</span> <strong>{{ equipamentoSelecionado.dataUltimaAtualizacao | date: 'dd/MM/yyyy HH:mm' }}</strong></div>
            <div class="col-3"><span class="text-500">Status Integração:</span> <app-tag-status [status]="equipamentoSelecionado.statusIntegracao"></app-tag-status></div>
            <div class="col-9"><span class="text-500">Mensagem:</span> <strong>{{ equipamentoSelecionado.mensagem }}</strong></div>
        </div>

    </div>

    <ng-template pTemplate="footer">
        <p-button label="Fechar" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="displayDetalhesDialog = false"></p-button>
    </ng-template>
</p-dialog>
